<template lang="pug">
with-actions(
  v-on="$listeners"
)
  .list.text-body-1
    p Зайдите в раздел #[a(href="/events/moderation" target="_blank").link "Модерация мероприятий"]&nbsp;
      | и подтвердите статус заявок, если они есть
    p Ознакомьтесь с #[a(href="/important-events" target="_blank").link Календарем значимых мероприятий]
    p Ознакомьтесь с #[a(href="/gifted-children" target="_blank").link Реестром одаренных детей]
    p Прочитайте наши #[a(href="/instructions" target="_blank").link Инструкции]
</template>

<script>
import WithActions from '../components/WithActions.vue';

export default {
  name: 'DepartmentWelcome',
  components: {
    WithActions,
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
